<template>
  <div class="app">
    <app-header fixed>
      <b-navbar variant="faded" type="light">
        <b-navbar-brand href="#">
          <img height="35" src="img/logo-esa.svg" alt="Logo Green Gapara" />
        </b-navbar-brand>
      </b-navbar>
      <b-navbar-nav>
        <b-dropdown variant="link" :text="modulName">
          <div class="shortcut-link p-3 mt-2 mb-2">
            <b-shortcut :menus="navItems"></b-shortcut>
          </div>
        </b-dropdown>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <div class="d-sm-down-none pl-2 title font-weight-bold">{{user.company}}</div>
        <b-tasknotif />
        <b-account @logout="logout" @profile="profile" />
      </b-navbar-nav>
    </app-header>
    <div class="app-body">
      <main class="main">
        <div class="container-fluid">
          <div class="mb-4"></div>
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-header {
  .app-logo {
    height: 52px;
  }

  .header-dropdown {
    margin-right: 20px;
  }
}

.shortcut-link {
  width: 900px;
  max-width: 900px;
}

.popover {
  width: 90%;
  max-width: 90%;
}
</style>

<script>
import { Header as AppHeader } from "@coreui/vue";
import bAccount from "../components/account";
import bTasknotif from "../components/tasknotify";
import bShortcut from "../components/shortcut-menus-small";
import auth from "../apis/auth.js";

export default {
  components: { AppHeader, bAccount, bTasknotif, bShortcut },
  data() {
    return { user: {}, navItems: [] };
  },
  methods: {
    modulClick() {
      // this.$router.push({ name: "app.modules" });
      if (process.env.VUE_APP_MYAPP){
        location.href = process.env.VUE_APP_MYAPP;
      }
    },
    logout() {
      boogr.logout();
    },
    profile() {
      this.$router.push("/profile");
    },
    // myapp() {
    //   location.href = process.env.VUE_APP_MYAPP;
    // }
  },
  created: async function() {
    const { $store } = this;

    if ($store.state.user) this.user = $store.state.user;
    this.user.company = this.user.company || "PT. Media Inisiatif";
    try {
        // const [menus] = await Promise.all([ auth.menus(this.name)]) ;
        // this.navItems = menus;
        // $store.commit("menu", this.navItems);
        const menus = await auth.menus(this.name);
        this.navItems = menus;
        $store.commit("menu", this.navItems);
        this.$socket.emit('user_join', this.$store.state.user)
    } catch (error) {
      console.log("error : ", error);
      this.$router.push({ name: "page.login" });
    }
  },
  computed: {
    name() {
      // return this.$route.name;
      // let routeRecords = this.$route.matched.filter(
      //   route => route.name || route.meta.label
      // );
      // this.$store.commit("modul", routeRecords[0].name);
      // return routeRecords[0].name;
      this.$store.commit("modul", process.env.VUE_APP_MODUL);
     return process.env.VUE_APP_MODUL;
    },
    modulName() {
      // return this.$route.name;
      // let routeRecords = this.$route.matched.filter(
      //   route => route.name || route.meta.label
      // );
      // return routeRecords[0].meta.label || "Menu";
     return (process.env.VUE_APP_MODUL).toUpperCase();
    },
    saveOrder(){
      return this.$store.state.saveOrder;
    }
  },
  // sockets: {
  //       connect: function () {
  //           console.log('socket connected')
  //       },
  //       disconnect: () => {
  //         console.log('socket.io : a user disconnected');
  //       },
  //       saveOrder: function (data) {
  //           console.log('saveOrder :',data)
  //       },
  // }
};
</script>
